import React from "react";

import BankCandidateIcon from "@/Components/Icons/BankCandidateIcon";
import { NonBankCandidateIcon } from "@/Components/Icons/NonBankCandidateIcon";

const IsBankCandidate = ({
  is_bank_candidate = "0",
  is_for_appLocum_candidates = 1,
}) => {
  const isBank = is_bank_candidate === "1" || is_bank_candidate === 1;

  const getCandidateView = () => {
    const isAppLocum = is_for_appLocum_candidates && !isBank;

    const containerClasses = `
      flex items-center gap-2 rounded-[4px] px-2 py-1 text-center font-medium leading-[23px]
      ${isAppLocum ? "h-[27px] w-[105px] bg-lightblue text-primary" : "h-[23px] w-[75px] bg-green-200 text-green_five_color"}
    `;

    const icon = isAppLocum ? (
      <NonBankCandidateIcon cls="text-primary" />
    ) : (
      <BankCandidateIcon cls="text-green" />
    );

    const text = isAppLocum ? "AppLocum" : "Bank";
    const textClasses = isAppLocum
      ? "text-[12px] text-primary"
      : "text-[12px] text-green";

    return (
      <div className={containerClasses}>
        {icon}
        <span className={textClasses}>{text}</span>
      </div>
    );
  };

  return <>{getCandidateView()}</>;
};

export default IsBankCandidate;
